import React, { useEffect, useState } from 'react';
import { Info, X } from 'lucide-react';
import styles from './MileageAnalysisTab_bus.module.css';
import ModalGauge from './ModalGauge';
import ModalBarChart from './ModalBarChart';
import TooltipTableModal from './TooltipTableModal';
import useHttp from '../../../../hook/use-http';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates_bus';
import { useVehicleData } from './context';


const initialObject = {
  averageSpeed: { primaryVehicle: null, bestVehicle: null, secondaryVehicle: null },
  vehicleSpeedDistribution: { primaryVehicle: null, bestVehicle: null, secondaryVehicle: null },
  accPedalPosition: { primaryVehicle: null, bestVehicle: null, secondaryVehicle: null },
  harshAcceleration: { primaryVehicle: null, bestVehicle: null, secondaryVehicle: null },
  harshBreaking: { primaryVehicle: null, bestVehicle: null, secondaryVehicle: null },
  rushTurning: { primaryVehicle: null, bestVehicle: null, secondaryVehicle: null },
  overSpeeding: { primaryVehicle: null, bestVehicle: null, secondaryVehicle: null },
  drivingScore: { primaryVehicle: null, bestVehicle: null, secondaryVehicle: null }, // Assuming you'll calculate or get this from elsewhere
  idling: { primaryVehicle: null, bestVehicle: null, secondaryVehicle: null },
  coasting: { primaryVehicle: null, bestVehicle: null, secondaryVehicle: null },
  regeneration: { primaryVehicle: null, bestVehicle: null, secondaryVehicle: null },
  RPM: { primaryVehicle: null, bestVehicle: null, secondaryVehicle: null }
}

const DrivingBehaviorCard = ({ vehicleData, selectedVehicleData, globalFilter, customFilter, benchmarkType }) => {
  const { GlobalData, setGlobalData } = useVehicleData();
  const { firstVinNo, secondVinNo } = selectedVehicleData
  // const [nationalBestVehicle, setNationalBestVehicle] = useState("")
  // const [overallBestVehicle, setOverallBestVehicle] = useState("")


  const [activeGraph, setActiveGraph] = useState(null);
  const [modalGaugeData, setModalGaugeData] = useState({ title: "", value: 0, bestDayValue: 0, currentDayValue: 0 })
  const [tooltipModalData, setTooltipModalData] = useState({
    key: "",
    label: ""
  });
  const { isLoading, error, sendReq: fetchData } = useHttp();

  const [VehicleData, setVehicleData] = useState(initialObject);

  const [primaryVehicleData, setPrimaryVehicleData] = useState(
    {
      averageSpeed: null,
      vehicleSpeedDistribution: null,
      accPedalPosition: null,
      harshAcceleration: null,
      harshBreaking: null,
      rushTurning: null,
      overSpeeding: null,
      drivingScore: null, // Assuming you'll calculate or get this from elsewhere
      idling: null,
      coasting: null,
      regeneration: null,
      RPM: null,
      AC_Consumption: null,
    }
  )

  const [bestVehicleData, setBestVehicleData] = useState(
    {
      averageSpeed: null,
      vehicleSpeedDistribution: null,
      accPedalPosition: null,
      harshAcceleration: null,
      harshBreaking: null,
      rushTurning: null,
      overSpeeding: null,
      drivingScore: null, // Assuming you'll calculate or get this from elsewhere
      idling: null,
      coasting: null,
      regeneration: null,
      RPM: null,
      AC_Consumption: null,
    }
  )

  const [secondaryVehicleData, setSecondaryVehicleData] = useState(
    {
      averageSpeed: null,
      vehicleSpeedDistribution: null,
      accPedalPosition: null,
      harshAcceleration: null,
      harshBreaking: null,
      rushTurning: null,
      overSpeeding: null,
      drivingScore: null,
      idling: null,
      coasting: null,
      regeneration: null,
      RPM: null,
      AC_Consumption: null,
    }
  )

  const [nationalVehicleData, setNationalVehicleData] = useState(
    {
      averageSpeed: null,
      vehicleSpeedDistribution: null,
      accPedalPosition: null,
      harshAcceleration: null,
      harshBreaking: null,
      rushTurning: null,
      overSpeeding: null,
      drivingScore: null,
      idling: null,
      coasting: null,
      regeneration: null,
      RPM: null,
      AC_Consumption: null,
    }
  )

  const [depotVehicleData, setDepotVehicleData] = useState(
    {
      averageSpeed: null,
      vehicleSpeedDistribution: null,
      accPedalPosition: null,
      harshAcceleration: null,
      harshBreaking: null,
      rushTurning: null,
      overSpeeding: null,
      drivingScore: null,
      idling: null,
      coasting: null,
      regeneration: null,
      RPM: null,
      AC_Consumption: null,
    }
  )


  useEffect(() => {
    setGlobalData(prev => ({ ...prev, drivingBehavior: { ...prev.drivingBehavior, primaryVehicleData, bestVehicleData, secondaryVehicleData, nationalVehicleData, depotVehicleData } }))
  }, [primaryVehicleData, bestVehicleData, secondaryVehicleData, nationalVehicleData, depotVehicleData])

  useEffect(() => {
    if (firstVinNo?.vehicleId) {
      fetchData(
        {
          url: API_URL_MAIN + `mileage_analysis/mileage_analysis_Driving_Behaviour`,
          body: {
            filterdata: {
              ...globalFilter,
              "VIN_NUM": [firstVinNo?.vehicleId],
            }
          }
        },
        (res) => {

          const data = res[0] || []
          setPrimaryVehicleData(prevState => ({
            ...prevState,
            averageSpeed: data.averageOfSpeed?.value?.toFixed(2) ?? null,
            vehicleSpeedDistribution: data.Vehicle_Speed_Distribution?.value?.toFixed(2) ?? null,
            accPedalPosition: data["Accelarator Pedal"]?.value?.toFixed(2) ?? null,
            harshAcceleration: data.Harsh_Acceleration?.value?.toFixed(2) ?? null,
            harshBreaking: data.Harsh_Braking?.value?.toFixed(2) ?? null,
            rushTurning: data.Rash_Turning?.value?.toFixed(2) ?? null,
            overSpeeding: data.Over_Speeding?.value?.toFixed(2) ?? null,
            drivingScore: data?.drive_Score?.value?.toFixed(2) ?? null,
            idling: data.Idling?.value?.toFixed(2) ?? null,
            coasting: data.Coasting?.value?.toFixed(2) ?? null,
            regeneration: data.Regeneration?.value?.toFixed(2) ?? null,
            RPM: data.RPM?.value?.toFixed(2) ?? null,
            AC_Consumption: data.AC_Consumption?.value?.toFixed(2) ?? null,
          }))
        }
      );
    }

  }, [firstVinNo?.vehicleId, globalFilter])

  useEffect(() => {
    if (firstVinNo?.vehicleId) {
      fetchData(
        {
          url: API_URL_MAIN + `mileage_analysis/mileage_analysis_best_driven_Driving_Behaviour`,
          body: {
            filterdata: {
              ...globalFilter,
              bestDate: GlobalData.bestVehicle,
              "VIN_NUM": [firstVinNo?.vehicleId],
            }
          }
        },
        (res) => {

          const data = res[0] || []
          setBestVehicleData(prevState => ({
            ...prevState,
            averageSpeed: data.averageOfSpeed?.value?.toFixed(2) ?? null,
            vehicleSpeedDistribution: data.Vehicle_Speed_Distribution?.value?.toFixed(2) ?? null,
            accPedalPosition: data["Accelarator Pedal"]?.value?.toFixed(2) ?? null,
            harshAcceleration: data.Harsh_Acceleration?.value?.toFixed(2) ?? null,
            harshBreaking: data.Harsh_Braking?.value?.toFixed(2) ?? null,
            rushTurning: data.Rash_Turning?.value?.toFixed(2) ?? null,
            overSpeeding: data.Over_Speeding?.value?.toFixed(2) ?? null,
            drivingScore: data.drive_Score?.value?.toFixed(2) ?? null,
            idling: data.Idling?.value?.toFixed(2) ?? null,
            coasting: data.Coasting?.value?.toFixed(2) ?? null,
            regeneration: data.Regeneration?.value?.toFixed(2) ?? null,
            RPM: data.RPM?.value?.toFixed(2) ?? null,
            AC_Consumption: data.AC_Consumption?.value?.toFixed(2) ?? null,
          }))

          // setOverallBestVehicle(data?.key?.eventdate)


        }
      );
    }

  }, [firstVinNo?.vehicleId, globalFilter, GlobalData?.bestVehicle])

  useEffect(() => {
    let drivingBehaviorAPiCustom = "mileage_analysis_Driving_Behaviour"
    let drivingBehaviorAPiDepot = "mileage_analysis_depo_Driving_Behaviour"
    let drivingBehaviorAPiNational = "mileage_analysis_national_Driving_Behaviour"

    setSecondaryVehicleData({
      averageSpeed: null,
      vehicleSpeedDistribution: null,
      accPedalPosition: null,
      harshAcceleration: null,
      harshBreaking: null,
      rushTurning: null,
      overSpeeding: null,
      drivingScore: null,
      idling: null,
      coasting: null,
      regeneration: null,
      RPM: null,
      AC_Consumption: null,
    })


    // custom
    if (secondVinNo?.vehicleId) {
      fetchData(
        {
          url: API_URL_MAIN + `mileage_analysis/${drivingBehaviorAPiCustom}`,
          body: {
            filterdata: {
              ...customFilter,
              "VIN_NUM": [secondVinNo?.vehicleId],
            }
          }
        },
        (res) => {
          const data = res[0] || []


          setSecondaryVehicleData(prevState => ({
            ...prevState,
            averageSpeed: data?.averageOfSpeed?.value?.toFixed(2) ?? null,
            vehicleSpeedDistribution: data?.Vehicle_Speed_Distribution?.value?.toFixed(2) ?? null,
            accPedalPosition: data?.["Accelarator Pedal"]?.value?.toFixed(2) ?? null,
            harshAcceleration: data?.Harsh_Acceleration?.value?.toFixed(2) ?? null,
            harshBreaking: data?.Harsh_Braking?.value?.toFixed(2) ?? null,
            rushTurning: data?.Rash_Turning?.value?.toFixed(2) ?? null,
            overSpeeding: data?.Over_Speeding?.value?.toFixed(2) ?? null,
            drivingScore: data?.drive_Score?.value?.toFixed(2) ?? null,
            idling: data?.Idling?.value?.toFixed(2) ?? null,
            coasting: data?.Coasting?.value?.toFixed(2) ?? null,
            regeneration: data?.Regeneration?.value?.toFixed(2) ?? null,
            RPM: data?.RPM?.value?.toFixed(2) ?? null,
            AC_Consumption: data?.AC_Consumption?.value?.toFixed(2) ?? null,
          }))
          // if (benchmarkType == "National") {
          //   setNationalBestVehicle(data?.key?.vehicleId)
          // }
        }
      );
    }

    // depot
    let vinNoDepot = GlobalData?.bestDepoVehicleId ? [GlobalData?.bestDepoVehicleId] : []
    fetchData(
      {
        url: API_URL_MAIN + `mileage_analysis/${drivingBehaviorAPiDepot}`,
        body: {
          filterdata: {
            ...globalFilter,
            "VIN_NUM": vinNoDepot,
          }
        }
      },
      (res) => {
        const data = res[0] || []


        setDepotVehicleData(prevState => ({
          ...prevState,
          averageSpeed: data?.averageOfSpeed?.value?.toFixed(2) ?? null,
          vehicleSpeedDistribution: data?.Vehicle_Speed_Distribution?.value?.toFixed(2) ?? null,
          accPedalPosition: data?.["Accelarator Pedal"]?.value?.toFixed(2) ?? null,
          harshAcceleration: data?.Harsh_Acceleration?.value?.toFixed(2) ?? null,
          harshBreaking: data?.Harsh_Braking?.value?.toFixed(2) ?? null,
          rushTurning: data?.Rash_Turning?.value?.toFixed(2) ?? null,
          overSpeeding: data?.Over_Speeding?.value?.toFixed(2) ?? null,
          drivingScore: data?.drive_Score?.value?.toFixed(2) ?? null,
          idling: data?.Idling?.value?.toFixed(2) ?? null,
          coasting: data?.Coasting?.value?.toFixed(2) ?? null,
          regeneration: data?.Regeneration?.value?.toFixed(2) ?? null,
          RPM: data?.RPM?.value?.toFixed(2) ?? null,
          AC_Consumption: data?.AC_Consumption?.value?.toFixed(2) ?? null,
        }))
        // if (benchmarkType == "National") {
        //   setNationalBestVehicle(data?.key?.vehicleId)
        // }
      }
    );

    // national
    let vinNonNational = GlobalData?.nationalVehicleId ? [GlobalData?.nationalVehicleId] : []
    fetchData(
      {
        url: API_URL_MAIN + `mileage_analysis/${drivingBehaviorAPiNational}`,
        body: {
          filterdata: {
            ...globalFilter,
            "VIN_NUM": vinNonNational,
          }
        }
      },
      (res) => {
        const data = res[0] || []
        setNationalVehicleData(prevState => ({
          ...prevState,
          averageSpeed: data?.averageOfSpeed?.value?.toFixed(2) ?? null,
          vehicleSpeedDistribution: data?.Vehicle_Speed_Distribution?.value?.toFixed(2) ?? null,
          accPedalPosition: data?.["Accelarator Pedal"]?.value?.toFixed(2) ?? null,
          harshAcceleration: data?.Harsh_Acceleration?.value?.toFixed(2) ?? null,
          harshBreaking: data?.Harsh_Braking?.value?.toFixed(2) ?? null,
          rushTurning: data?.Rash_Turning?.value?.toFixed(2) ?? null,
          overSpeeding: data?.Over_Speeding?.value?.toFixed(2) ?? null,
          drivingScore: data?.drive_Score?.value?.toFixed(2) ?? null,
          idling: data?.Idling?.value?.toFixed(2) ?? null,
          coasting: data?.Coasting?.value?.toFixed(2) ?? null,
          regeneration: data?.Regeneration?.value?.toFixed(2) ?? null,
          RPM: data?.RPM?.value?.toFixed(2) ?? null,
          AC_Consumption: data?.AC_Consumption?.value?.toFixed(2) ?? null,
        }))
        // if (benchmarkType == "National") {
        //   setNationalBestVehicle(data?.key?.vehicleId)
        // }
      }
    );


  }, [secondVinNo?.vehicleId, GlobalData?.nationalVehicleId, GlobalData?.bestDepoVehicleId, customFilter, globalFilter, benchmarkType])



  const infoBandTexts = {
    'Vehicle Speed Distribution': '30-50',
    'Acc. Pedal Position': '20-40',
    'Gear Utilization Distribution': 'Gear 8',
    'Energy Efficiency Mode Distribution': 'Light Mode',
    'RPM': '1000-2000'
  };

  const handleTooltipClick = (key, label) => {
    setTooltipModalData({
      key, label
    });
  };



  const handleGraphClick = (row, currentValue) => {
    let label = row.label
    setActiveGraph(label);
    setModalGaugeData({ ...VehicleData?.[row.key], label, currentValue })
  };

  const handleBarChartClick = (row, currentValue, vehicleType) => {
    let label = row.label
    setActiveGraph(label);
    setModalGaugeData({ ...VehicleData?.[row.key], label, currentValue })
    setBarChartInfo(prev => ({
      ...prev,
      barName: row.key,
      vehicleType: vehicleType
    }))
  };

  const drivingRows = [
    {
      key: 'averageSpeed',
      label: 'Average Speed',
    },
    {
      key: 'vehicleSpeedDistribution',
      label: 'Vehicle Speed Distribution',
      band: '30-50',
      hasInfo: true,
      isGraphRow: true,
      hasBarChart: true,
    },
    {
      key: 'accPedalPosition',
      label: 'Acc. Pedal Position',
      band: '20-40',
      hasInfo: true,
      isGraphRow: true,
      hasBarChart: true,
    },
    {
      key: 'harshAcceleration',
      label: 'Harsh Acceleration',
    },
    {
      key: 'harshBreaking',
      label: 'Harsh Braking',
    },
    {
      key: 'rushTurning',
      label: 'Rash Turning',
    },
    {
      key: 'overSpeeding',
      label: 'Overspeeding',
    },
    {
      key: 'drivingScore',
      label: 'Driving Score',
    },
    {
      key: 'idling',
      label: 'Idling',
      isGraphRow: true,
      hasGaugeChart: true,
    },
    {
      key: 'coasting',
      label: 'Coasting',
      isGraphRow: true,
      hasGaugeChart: true,
    },
    {
      key: 'regeneration',
      label: 'Regeneration',
      isGraphRow: true,
      hasGaugeChart: true,
    },
    {
      key: 'RPM',
      label: 'RPM',
      hasInfo: true,
      isGraphRow: true,
      hasBarChart: true,
    },
    {
      key: 'AC_Consumption',
      label: 'AC Consumption',
    },

  ];

  const [barChartInfo, setBarChartInfo] = useState({
    barName: "",
    vehicleType: ""
  })

  let graphChartTypeForSecondary = benchmarkType == "National" ? "National" : benchmarkType == "Depot" ? "Depo" : "secondary"

  return (
    <div className="mb-4">
      <div className="d-flex align-items-center mb-3">
        <h6 className={styles.sectionTitle}>
          Driving Behaviour :
        </h6>
      </div>

      <div className={styles.mainContainer}>
        {drivingRows.map((row, index) => {
          const {
            key,
            label,
            current,
            bestValue,
            isGraphRow,
            isClickableGraphRow,
            hasInfo,
            hasBarChart,
            shouldReduceSpacing,
            hasGaugeChart
          } = row;

          const isClickable = isGraphRow || isClickableGraphRow;
          const modalTarget = hasBarChart
            ? "#modalBarChart_MSbus"
            : hasGaugeChart ? "#modalGauge_MSbus"
              : undefined;

          return (
            <div key={label}>
              <div
                className={hasInfo ? 'row' : 'row mb-2'}
                style={hasInfo ? { marginBottom: '0.10rem' } : {}}
              >
                <div className="col-3">
                  <div className={styles.rowLabelContainer}>
                    <span className={styles.rowLabel}>{label}</span>

                    {hasInfo && infoBandTexts[label] && (
                      <div className={styles.infoBand}>
                        <span className={styles.infoBandText}>
                          {infoBandTexts[label]}
                        </span>
                        <Info
                          data-toggle="modal" data-target="#tooltipModal_MSbus"
                          size={12}
                          className={`${styles.infoBandIcon}`}
                          onClick={() => handleTooltipClick(key, label)}
                        />
                      </div>
                    )}
                  </div>
                </div>

                <div className="col-3">
                  <div
                    className={`${styles.rowValueContainer} ${hasInfo ? styles.tallRowValueContainer : ''} ${isClickable ? styles.clickableRow : ''}`}
                    onClick={hasBarChart ? () => handleBarChartClick(row, primaryVehicleData?.[key], "primary") : hasGaugeChart ? () => handleGraphClick(row, primaryVehicleData?.[key]) : undefined}
                  > {
                      primaryVehicleData?.[key] !== null ?
                        <span data-toggle="modal" data-target={modalTarget} className={`${styles.rowValue} ${isClickableGraphRow || isGraphRow ? styles.clickableValue : ''}`}>
                          {primaryVehicleData?.[key] !== null ? <> {primaryVehicleData?.[key]}{isClickableGraphRow || isGraphRow ? " %" : ''}</> : <>--</>}
                        </span>
                        : <>--</>
                    }
                  </div>
                </div>

                <div className="col-3">
                  <div
                    className={`${styles.rowValueContainer} ${hasInfo ? styles.tallRowValueContainer : ''} ${isClickable ? styles.clickableRow : ''}`}
                    onClick={hasBarChart ? () => handleBarChartClick(row, bestVehicleData?.[key], 'best') : hasGaugeChart ? () => handleGraphClick(row, bestVehicleData?.[key]) : undefined}
                  >
                    {
                      bestVehicleData?.[key] !== null ?
                        <span data-toggle="modal" data-target={modalTarget} className={`${styles.rowValue} ${isClickableGraphRow || isGraphRow ? styles.clickableValue : ''}`}>
                          {bestVehicleData?.[key]}{isClickableGraphRow || isGraphRow ? " %" : ''}
                        </span>
                        : <>--</>
                    }
                  </div>
                </div>

                <div className="col-3">
                  {
                    benchmarkType == "Custom" ?
                      <div className={`${styles.rowValueContainer} ${hasInfo ? styles.tallRowValueContainer : ''} ${isClickable ? styles.clickableRow : ''}`}
                        onClick={hasBarChart ? () => handleBarChartClick(row, secondaryVehicleData?.[key], graphChartTypeForSecondary) : isClickable ? () => handleGraphClick(row, secondaryVehicleData?.[key]) : undefined}
                      >{
                          secondaryVehicleData?.[key] !== null ?
                            <span data-toggle="modal" data-target={modalTarget} className={`${styles.rowValue} ${isClickableGraphRow || isGraphRow ? styles.clickableValue : ''}`}>
                              {secondaryVehicleData?.[key]}{isClickableGraphRow || isGraphRow ? " %" : ''}
                            </span>
                            : <>{secondVinNo?.vehicleId ? <>--</> : ""}</>
                        }
                      </div> :
                      benchmarkType == "National" ?
                        <div className={`${styles.rowValueContainer} ${hasInfo ? styles.tallRowValueContainer : ''} ${isClickable ? styles.clickableRow : ''}`}
                          onClick={hasBarChart ? () => handleBarChartClick(row, nationalVehicleData?.[key], graphChartTypeForSecondary) : isClickable ? () => handleGraphClick(row, nationalVehicleData?.[key]) : undefined}
                        >{
                            nationalVehicleData?.[key] !== null ?
                              <span data-toggle="modal" data-target={modalTarget} className={`${styles.rowValue} ${isClickableGraphRow || isGraphRow ? styles.clickableValue : ''}`}>
                                {nationalVehicleData?.[key]}{isClickableGraphRow || isGraphRow ? " %" : ''}
                              </span>
                              : <>--</>
                          }
                        </div> :
                        <div className={`${styles.rowValueContainer} ${hasInfo ? styles.tallRowValueContainer : ''} ${isClickable ? styles.clickableRow : ''}`}
                          onClick={hasBarChart ? () => handleBarChartClick(row, depotVehicleData?.[key], graphChartTypeForSecondary) : isClickable ? () => handleGraphClick(row, depotVehicleData?.[key]) : undefined}
                        >{
                            depotVehicleData?.[key] !== null ?
                              <span data-toggle="modal" data-target={modalTarget} className={`${styles.rowValue} ${isClickableGraphRow || isGraphRow ? styles.clickableValue : ''}`}>
                                {depotVehicleData?.[key]}{isClickableGraphRow || isGraphRow ? " %" : ''}
                              </span>
                              : <>--</>
                          }
                        </div>
                  }
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Modals */}
      <ModalGauge data={modalGaugeData} />
      <ModalBarChart data={modalGaugeData} selectedVehicleData={selectedVehicleData} globalFilter={globalFilter} barChartInfo={barChartInfo} customFilter={customFilter} />
      <TooltipTableModal data={tooltipModalData} globalFilter={globalFilter} selectedVehicleData={selectedVehicleData} benchmarkType={benchmarkType} />
    </div>
  );
};

export default DrivingBehaviorCard;